

document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll("[data-eventurl]").forEach( (eventElement) => {

        $.get( eventElement.dataset.eventurl, ( data ) => {
            eventElement.innerHTML = data;
        }).fail(function(error) {
           console.log(error);
        });
    });

    $('body').on("click", '.data-event-pagination', (e) => {
        e.preventDefault();
        let wrapper = e.target.closest('[data-eventurl]');
        wrapper.innerHTML = '<div class="la-ball-spin-fade-rotating la-dark m-auto la-3x">\n' +
            '\t<div></div>\n' +
            '\t<div></div>\n' +
            '\t<div></div>\n' +
            '\t<div></div>\n' +
            '\t<div></div>\n' +
            '\t<div></div>\n' +
            '\t<div></div>\n' +
            '\t<div></div>\n' +
            '</div>';
        $.get( e.target.getAttribute('href') ?? e.target.closest('.data-event-pagination').getAttribute('href'), ( data ) => {
            wrapper.innerHTML = data;
        }).fail(function(error) {
            console.log(error);
        });

    });

});
